// extracted by mini-css-extract-plugin
export default {"recoCarousel":"faa-z","fullMaxWidth":"gaa-z"};